<template>
  <div class="content">	 
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <h4 class="card-title">订单管理</h4>
          </template>
          <div class="search">
			  <input type="text" class="form-control col-2" placeholder="客户名称" aria-label="客户名称" aria-describedby="basic-addon1"  v-model="searchParams.companyName">
			  <input type="text" class="form-control col-2" placeholder="订单编号" aria-label="订单编号" aria-describedby="basic-addon1"  v-model="searchParams.orderNo">			  
			  <input type="text" class="form-control col-2" placeholder="合同编码" aria-label="合同编码" aria-describedby="basic-addon1"  v-model="searchParams.contractNo">
			  <input type="text" class="form-control col-2" placeholder="物料编码" aria-label="物料编码" aria-describedby="basic-addon1"  v-model="searchParams.materialNo">
			  <button type="button" class="btn btn-primary" @click="searchParams.pageNum=1;search()">查找</button>
		  </div>
          <div class="table-responsive text-left">
			  <el-table class="table" 
			  :data="orders" width="100%"  
			  @current-change="handleCurrenChange"
			  highlight-current-row
			  tooltip-effect="dark"
			  >
			  <el-table-column prop="companyName" label="公司名称"  width="250px"></el-table-column>
			  <el-table-column prop="orderCreated" label="创建时间"></el-table-column>
			  <el-table-column prop="orderNo" label="订单编码"></el-table-column>
			  <el-table-column prop="contractNo" label="合同编码"></el-table-column>
			  <el-table-column prop="materialNo" label="物料编码"></el-table-column>
			  <el-table-column prop="model" label="型号" width="300px"></el-table-column>
			  <el-table-column prop="number" label="数量" width="50px"></el-table-column>
			  <el-table-column prop="delivery" label="货期"></el-table-column>
			  <el-table-column label="操作">
				  <template slot-scope="scope">
					<el-button size="mini" type='button' @click="status(scope.row.ydnNo)">查看</el-button>
					<el-button size="mini" type='button' @click="del(scope.row.orderId)">删除</el-button>
				  </template>
			   </el-table-column>  
			  </el-table>
          </div>
		  
		  <nav aria-label="Page navigation example" style="margin-top:30px;">
		    <ul class="pagination justify-content-center">
		      <li class="page-item" id="previous" :class="{'disabled':searchParams.pageNum==1}">
		        <a class="page-link" href="#" @click="previous()">Previous</a>
		      </li>
			  <li class='page-item' style="margin-left: 5px;margin-right: 5px;"> page {{searchParams.pageNum}} of {{pages}} </li>			  
		      <li class="page-item" id="next" :class="{'disabled':searchParams.pageNum==pages}">
		        <a class="page-link" href="#" @click="next()">Next</a>
		      </li>	
			  <li class="pageSize" style="margin-left: 5px;"> 每页：<span><a href="#" @click="searchParams.pageSize=10;searchParams.pageNum=1;search();">10</a></span><span><a href="#" @click="searchParams.pageSize=50;searchParams.pageNum=1;search();">50</a></span><span><a href="#"  @click="searchParams.pageSize=100;searchParams.pageNum=1;search();">100</a></span></li>
			</ul>
		  </nav>	  
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Card } from "@/components/index";
import Cookies from "js-cookie";
import Modal from "@/pages/Layout/Modal.vue";
import { Message,MessageBox} from "element-ui";
export default {
  components: {Card,Modal},
  data() {
    return {
	  searchParams:{
	  	contractNo:"",
	  	materialNo:"",
		companyName:"",
		orderNo:"",
		pageSize:10,
		pageNum:1, 
	  },
	  orders:[],
	  proOrder:{},
	  orderState:"",
	  pages:1,
	  pageNav:"",
	  showModal:false,
	  proName:[],
	  orderId:"",	  
	  wait:true,
	  lc:false,
	  currentRow:null,
    };
  },
  created() {
	  this.searchParams.pageNum=1;
	  this.search();
  },
  methods: {
  	async search() {
  		let res =await this.$axios.post(this.$serverUrl+"/order/searchByYewu",this.searchParams);
		if(res.data.state==200){
		this.orders=res.data.data.list;
		this.pages=res.data.data.pages;
		}
  	},
	previous(){
		this.searchParams.pageNum=this.searchParams.pageNum-1;
		this.search();
	},
	next(){
		this.searchParams.pageNum=this.searchParams.pageNum+1;
		this.search();
	},
	handleCurrenChange(val){
		this.currentRow=val;
	},
	status(orderNo){
		var url=this.$url+"/#/lc?id="+encodeURIComponent(orderNo);
		window.open(url);
	},
	del(val){
		MessageBox.confirm("确定要删除 “"+this.currentRow.companyName+"”的订单 ?","确认",{
		  distinguishCancelAndClose: true,
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning',
		  offset:window.screen.height/2-100
		}).then(()=>{
		    this.$axios.post(this.$serverUrl+"/order/del",{orderId:val}).then(
				response => {			
				  if(response.data.state==200){
					this.search();
				  }else{
					Message(
					{
					 type: "error",
					 message: response.data.msg,
					 offset:window.screen.height/2-100
					});
				  }
				}
			).catch(			
				error=>{
					if(error.response.data.state===500){
					Message(
					{
					 type: "error",
					 message: "系统出错了。",
					 offset:window.screen.height/2-100
					});
					}
			})
			});
	},
  },
};
</script>
<style>
	.search input{
		display:inline;
		margin-right:5px;
	}
	.page-link{
		color: #000;
	}
	.pageSize a{
	    margin-left: 10px;	
	}
	.el-table__body-wrapper {
	  overflow-x: auto;
	}
	.modal-container{
		width:700px;
	}
	.modal-open {
	    overflow: hidden;
	}
</style>